module.exports = __webpack_public_path__ + "static/media/suplimentary_form_last.0fca592a.png";